
class InstallmentTemplateSelectCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set title(text:string){
        this.nameLabel.text = text;
    }
}

// Popover to choose the invoice payment template (DIRECT when none) with a footer
// for the installments start date, so the header stays clean.
class InstallmentTemplateSelectViewController extends MUIViewController
{
    static newInstance() : InstallmentTemplateSelectViewController {
        let vc = new InstallmentTemplateSelectViewController("installment-template-select-view");
        vc.initWithResource("layout/installment_templates/InstallmentTemplateSelectView.html");
        return vc;
    }

    get preferredContentSize(): MIOSize {
        return new MIOSize(320, 400);
    }

    invoice:Invoice = null;
    completionTarget:any = null;
    completionBlock:any = null;

    private tableView:UITableView = null;
    private startDateTextField:MUITextField = null;
    private templates:PaymentInstallmentTemplate[] = [];

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.startDateTextField = MUIOutlet(this, "start-date-tf", "MUITextField");
        this.startDateTextField.setOnChangeText(this, function(this:InstallmentTemplateSelectViewController, control:MUITextField, value:string){
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            this.invoice.paymentInstallmentsStartDate = value.trim().length > 0 ? ad.dateFormatter.dateFromString(value) : null;
        });
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.startDateTextField.text = this.invoice.paymentInstallmentsStartDate != null ? ad.dateFormatter.stringFromDate(this.invoice.paymentInstallmentsStartDate) : null;

        DBHelper.queryObjectsWithCompletion("PaymentInstallmentTemplate", [MIOSortDescriptor.sortDescriptorWithKey("name", true)], MIOPredicate.predicateWithFormat("deletedAt == null"), [], this, function(this:InstallmentTemplateSelectViewController, objects){
            this.templates = objects;
            if (this.viewIsLoaded) this.tableView.reloadData();
        });
    }

    numberOfSections(tableView:UITableView){
        return 1;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return this.templates.length + 1;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("TemplateCell") as InstallmentTemplateSelectCell;

        let template = indexPath.row == 0 ? null : this.templates[indexPath.row - 1];
        cell.title = template != null ? template.name : MIOLocalizeString("DIRECT", "DIRECT");
        cell.accessoryType = (this.invoice.paymentInstallmentTemplate == template) ? UITableViewCellAccessoryType.Checkmark : UITableViewCellAccessoryType.None;

        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let template = indexPath.row == 0 ? null : this.templates[indexPath.row - 1];

        this.invoice.paymentInstallmentTemplate = template;
        this.invoice.paymentInstallmentTemplateName = template != null ? template.name : null;

        this.tableView.reloadData();

        if (this.completionBlock != null && this.completionTarget != null) this.completionBlock.call(this.completionTarget, template);
    }
}
